import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import {useTranslation} from "react-i18next";
import {RightSidebarActionButton} from "../../../layout/rightSidebar/RightSidebarRail";
import {useServerTableContext} from "../ServerTableContext";

export function ServerTableRailFullscreen() {
    const {t} = useTranslation();
    const {isFullScreen, setIsFullScreen} = useServerTableContext();
    const label = t(isFullScreen ? "Exit full screen" : "Enter full screen");

    return (
        <RightSidebarActionButton
            icon={isFullScreen ? <FullscreenExitOutlinedIcon/> : <FullscreenOutlinedIcon/>}
            label={label}
            active={isFullScreen}
            onClick={() => setIsFullScreen(!isFullScreen)}
        />
    );
}
